import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Space,
  Button,
  Tag,
  Modal,
  Popconfirm,
  message,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, BulbOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { AuthContext } from "../../../context/auth-context/AuthContext";
import apiService from "../../../services/apiServices";
import ModalEditar from "./ModalEditar";
import ModalCrear from "./ModalCrear";


//cumple la regla de contraseñas del alta (8+ caracteres, una mayuscula y un simbolo)
const generarContrasenaTemporal = () => {
  const letras = "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const valores = new Uint32Array(8);
  window.crypto.getRandomValues(valores);
  const cuerpo = Array.from(valores, (v) => letras[v % letras.length]).join("");
  return `Inm-${cuerpo}!`;
};


export const AdminComponent = ({ isDarkMode, changeTheme, handleLogout, embebido = false }) => {
  const [modal, contextoModal] = Modal.useModal();
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [editingUser, setEditingUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  //tomemos el authState desde el context
  const { authState, handleRefreshToken } = React.useContext(AuthContext);
  //const [listUsers, setlistUsers] = useState([])
  const [createModalOpen, setCreateModalOpen] = useState(false);  

  const handleGlobalSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = users.filter((u) =>
      `${u.firstName} ${u.lastName} ${u.username} ${u.email}`.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const getDataUsers = async () => {
    try {
      const tokenVerified = await handleRefreshToken();
      const datosUsuarios = await apiService.getUsersList(tokenVerified);
      return datosUsuarios;
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Error al cargar los usuarios");
      return null;
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={confirm}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
  });

  const handleEdit = (user) => {
   console.log("%c DATOS DEL REGISTRO DE USUARIO A EDITAR","color: teal", user); 
    setEditingUser(user);
//    console.log("%c STATE EDITITNG USER","color: green", editingUser);
    form.setFieldsValue(user);
    setOpen(true);
  };

  const handleSave = () => {
    form.validateFields().then((values) => {
      const newData = users.map((u) =>
        u.id === editingUser.id ? { ...u, ...values } : u
      );
      setUsers(newData);
      setFilteredData(newData);
      setOpen(false);
      message.success("Usuario actualizado");
    });
  };

  const handleDelete = async(id) => {
    try {
      const tokenVerified = await handleRefreshToken();
      const res = await apiService.deleteOneUser(id, tokenVerified);
      if (!res.ok && res.error) {
        message.error(res.error || "Error al eliminar el usuario");
        return false;
      }
      //console.log("%c RES EN HANDLE DELETE","color: yellow", res);
      message.success("Usuario eliminado exitosamente");
      setRefreshTable(prev => !prev);
      // const newData = users.filter((u) => u.id !== id);
      // setUsers(newData);
      // setFilteredData(newData);
    } catch (error) {
      console.error("%c ERROR EN HANDLE DELETE","color: red", error);
      message.error("Error al eliminar el usuario");
      return false;  
    }   

  };

  const restablecerContrasena = (user) => {
    modal.confirm({
      title: `Restablecer la contraseña de ${user.username}`,
      content: "Se genera una contraseña temporal y la anterior deja de funcionar.",
      okText: "Restablecer",
      cancelText: "Cancelar",
      onOk: async () => {
        const temporal = generarContrasenaTemporal();
        try {
          const tokenVerified = await handleRefreshToken();
          //la API pone en null la fecha de fin si no viaja en el PUT, por eso se reenvia la actual
          await apiService.editUser(
            user.id,
            { password: temporal, subscriptionEndDate: user.subscriptionEndDate ?? null },
            tokenVerified
          );
          modal.success({
            title: "Contraseña restablecida",
            content: (
              <div>
                <p style={{ marginBottom: 8 }}>
                  Pasale esta contraseña a <b>{user.username}</b>. No se vuelve a mostrar.
                </p>
                <Typography.Paragraph
                  copyable={{ text: temporal, tooltips: ["Copiar", "Copiada"] }}
                  style={{ fontFamily: "Consolas, Menlo, monospace", fontSize: 16, margin: 0 }}
                >
                  {temporal}
                </Typography.Paragraph>
              </div>
            ),
            okText: "Listo",
          });
        } catch (error) {
          message.error("No se pudo restablecer la contraseña");
        }
      },
    });
  };

  const columns = [
    {
      title: "Nombre",
      key: "firstName",
      render: (_, record) => `${record.firstName} ${record.lastName}`,
      ...getColumnSearchProps("firstName"),
    },
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
      ...getColumnSearchProps("username"),
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Rol",
      dataIndex: "role",
      key: "role",
      filters: [
        { text: "SUPER_ADMIN", value: "SUPER_ADMIN" },
        { text: "ADMIN", value: "ADMIN" },
        { text: "USER", value: "USER" },
      ],
      onFilter: (value, record) => record.role === value,
    },
    {
      title: "Suscripción",
      dataIndex: "subscription",
      key: "subscription",
      filters: [
        { text: 'Free', value: 'free' },
        { text: 'Mensual', value: 'mensual' },
        { text: 'Anual', value: 'anual' },
      ],
      onFilter: (value, record) => record.subscription === value,
    },    

    {
      title: "Estado Suscripción",
      dataIndex: "subscriptionStatus",
      key: "subscriptionStatus",
      filters: [
        { text: "Active", value: "active" },
        { text: "Pendiente", value: "pending" },
        { text: "Suspendido", value: "suspend" },
        { text: "Cancelado", value: "cancel" },
      ],
      onFilter: (value, record) => record.subscriptionStatus === value,
    },
    {
      title: "Fecha Fin Suscripción",
      dataIndex: "subscriptionEndDate",
      key: "subscriptionEndDate",      
      render: (val) => !val ? "—" : new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      filters: [
        { text: "Starter", value: "starter" },
        { text: "Professional", value: "professional" },
        { text: "Corporate", value: "corporate" },
      ],
      onFilter: (value, record) => record.plan === value,
    },

    {
      title: "Experiencias Creadas",
      dataIndex: "experienceCount",
      key: "experienceCount",
      render: (val) => val || 0,
    },
    {
      title: "Límite de Experiencias",
      dataIndex: "experienceLimit",
      key: "experienceLimit",
      render: (val) => val || 3,
    },    

    {
      title: "Creado",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (val) => new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),

    },
    {
      title: "Actualizado",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (val) => new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),

    },
    {
      title: "Acciones",
      key: "actions",
      fixed: "right",
      render: (_, user) => (
        <Space>
          <Button onClick={() => handleEdit(user)} type="link">
            Editar
          </Button>
          <Button onClick={() => restablecerContrasena(user)} type="link">
            Restablecer contraseña
          </Button>
          <Popconfirm
            title="¿Eliminar este usuario?"
            onConfirm={() => handleDelete(user.id)}
          >
            <Button danger type="link">
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];


  const [refreshTable, setRefreshTable] = useState(false);
  useEffect(() => {
    const fetchUsers = async () => {
      const data = await getDataUsers();
      if (data) {
        data.sort((a, b) => (a.lastName || "").localeCompare(b.lastName || ""));
        console.log("%c DATA EN FETCH USERS","color: blue", data);
        setUsers(data);
        setFilteredData(data);
      }
    };

    fetchUsers();
  }, [refreshTable]);  

  if (embebido) {
    return (
      <div className="inm-pagina" style={{ maxWidth: "none" }}>
        {contextoModal}
        <header className="inm-pagina__cabecera">
          <div style={{ display: "flex", flexDirection: "column", gap: 4, flexGrow: 1 }}>
            <h1 className="inm-pagina__titulo">Usuarios</h1>
            <p className="inm-tenue" style={{ margin: 0 }}>
              {users.length} usuarios
            </p>
          </div>
          <Input
            allowClear
            prefix={<SearchOutlined />}
            placeholder="Buscar usuario o correo"
            aria-label="Buscar usuario"
            value={searchText}
            onChange={handleGlobalSearch}
            style={{ width: 260, maxWidth: "100%" }}
          />
          <Button type="primary" onClick={() => setCreateModalOpen(true)}>
            Nuevo usuario
          </Button>
        </header>
        <div className="inm-caja" style={{ padding: 0, overflow: "hidden" }}>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 1700 }}
          />
        </div>
        <ModalEditar open={open} setOpen={setOpen} setRefreshTable={setRefreshTable} data={editingUser} handleLogout={handleLogout} />
        <ModalCrear createModalOpen={createModalOpen} setCreateModalOpen={setCreateModalOpen} setRefreshTable={setRefreshTable} />
      </div>
    );
  }

  return (
    <div>
      {contextoModal}
      <div style={{ position: 'relative', marginBottom: 16 }}>
        <h2 
          style={{ 
            color: isDarkMode ? "white" : "black",
            textAlign: 'center',
            margin: '0',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          Administración de Usuarios
        </h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            style={{ marginRight: 8 }}
            onClick={() => setCreateModalOpen(true)}
          >
            Crear Usuario
          </Button>
          <Button
            type="primary"
            icon={<BulbOutlined />}
            onClick={changeTheme}
          ></Button>
        </div>
      </div>

      <Input
        placeholder="Buscar por nombre..."
        value={searchText}
        onChange={handleGlobalSearch}
        style={{ width: 300, marginBottom: 16 }}
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 5 }}        
        scroll={{ x: 1500 }} // Add horizontal scroll
        style={{ overflowX: 'auto' }} // Ensure horizontal scroll works
      />
      <ModalEditar open={open} setOpen={setOpen} setRefreshTable={setRefreshTable} data={editingUser} handleLogout={handleLogout} />
      <ModalCrear createModalOpen={createModalOpen} setCreateModalOpen={setCreateModalOpen} setRefreshTable={setRefreshTable}/>      
    </div>
  );
};
